import { useState, useCallback } from "react";

export const useChassisCopy = () => {
  const [copiedChassis, setCopiedChassis] = useState<string | null>(null);

  const copyChassis = useCallback(async (chassis: string): Promise<boolean> => {
    try {
      await navigator.clipboard.writeText(chassis);
      setCopiedChassis(chassis);
      setTimeout(() => setCopiedChassis(null), 2000); // Esconde o feedback após 2 segundos
      return true;
    } catch (err) {
      console.error('Erro ao copiar chassis para área de transferência:', err);
      return false;
    }
  }, []);

  const isCopied = useCallback((chassis: string) => {
    return copiedChassis === chassis;
  }, [copiedChassis]);

  return {
    copyChassis,
    isCopied,
    copiedChassis
  };
};
